module.exports = __webpack_public_path__ + "img/caja.1944832b.png";